import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.jpg";
import IMG3 from "../../assets/portfolio3.jpg";
import IMG4 from "../../assets/portfolio4.jpg";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.jpg";

// DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 0,
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=400&q=80",
    title: "E-commerce App | React Native & Strapi",
    github: "https://github.com/JTarrillo/ecommerce__react-native", // App móvil
    backend: "https://github.com/JTarrillo/ecommerce__react-native__strapi", // Backend Strapi
    demo: "https://github.com/JTarrillo/ecommerce__react-native",
  },
  {
    id: 1,
    image:
      "https://media.istockphoto.com/id/1249219777/photo/shopping-online-concept-parcel-or-paper-cartons-with-a-shopping-cart-logo-in-a-trolley-on-a.jpg?s=1024x1024&w=is&k=20&c=Gsr6lZkBHjjeP5o18w9_mvnWxMZBqB-ncOi6tqh87hM=", // Imagen tienda virtual proporcionada
    title: "Tienda Virtual | API PayPal",
    github: "https://github.com/JTarrillo/tienda_virtual.git",
    demo: "https://github.com/JTarrillo/tienda_virtual.git",
  },
  {
    id: 2,
    image:
      "https://media.istockphoto.com/id/2189887556/photo/doctor-on-video-conference-for-medical-consultation.jpg?s=1024x1024&w=is&k=20&c=RVJ_0PwWBjGeKMQbCdQOTOwuV0baZ4pvxh40W_5-ulA=", // Imagen sistema de clínica proporcionada
    title: "Sistema de Clínica de Turnos",
    github: "https://github.com/JTarrillo/Mepryl4.2",
    demo: "https://github.com/JTarrillo/Mepryl4.2/tree/main/SOLUCION%204.2",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80", // Imagen referencial de sistema
    title: "Gestión de contratos inmobiliarios",
    github: "https://github.com/JTarrillo/grupovivencia",
    demo: "https://github.com/JTarrillo/grupovivencia",
  },
  {
    id: 4,
    image: IMG4,
    title: "Maintaining tasks and tracking progress",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/16955822-Maintaining-tasks-and-tracking-progress",
  },
  {
    id: 6,
    image: IMG6,
    title: "Charts templates & infographics in Figma",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/15887665-Orion-UI-kit-Charts-templates-infographics-in-Figma",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, backend, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img
                  src={image}
                  alt={title}
                  style={{
                    width: "100%",
                    height: "220px",
                    objectFit: "cover",
                    borderRadius: "1rem",
                  }}
                />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a
                  href={github}
                  className="btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  Github App
                </a>
                {/* Botón Github Strapi eliminado */}
                <a
                  href={demo}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
